import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { AuthService } from "src/app/SayTS/auth.service";

type TestAccount = readonly [username: string, password: string];

// Fill in the preset accounts you want quick-login buttons for.
const TEST_ACCOUNTS: readonly TestAccount[] = [
  ["TestAdmin", "TestAdmin"],
  ["TestViewer", "TestViewer"],
  ["stauner", "stauner"],
  ["electrician", "electrician"],
];

@Component({
  selector: "app-test-login-selector",
  templateUrl: "./test-login-selector.component.html",
  styleUrl: "./test-login-selector.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestLoginSelectorComponent {
  private authService = inject(AuthService);

  protected accounts = TEST_ACCOUNTS;

  protected async loginAs(account: TestAccount): Promise<void> {
    const [username, password] = account;
    if (!username) return;
    await this.authService.loginUser({ username, password, rememberMe: false });
  }
}
